import PublicLayout from 'components/PublicSiteLayout/Base';
import FullHeightTwoColumnLayout from 'components/PublicSiteLayout/FullHeightTwoColumn';
import FeatureSlider from 'components/FeatureSlider';
import urlsContext from 'contexts/urls/urlsContext';
import { getQueryParams } from 'helpers/queryParams';
import getTreatments from 'helpers/split/getTreatments';
import { treatments as splitTreatments } from 'helpers/split/treatments';
import { getUser } from 'helpers/user/getUser';
import useTrackGoFromSms from 'hooks/useTrackGoFromSms';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import SectionLanding from 'partials/sign_in/_sectionLanding.js';
import ConnectOkta from 'partials/sign_in/connect-okta';
import getRedirectionPath from 'partials/sign_in/getRedirectionPath';
import { useContext, useState } from 'react';
import { wrapper } from 'store';

const dataTrackGOFromSMS = (utmMedium, utmSource, utmCampaign) => {
	return {
		utm_medium: utmMedium,
		utm_source: utmSource,
		utm_campaign: utmCampaign,
	};
};

const SignIn = () => {
	const { t } = useTranslation('signin');
	const router = useRouter();
	const { passwordForgot, signUpUrl } = useContext(urlsContext);
	const refererUrl = router.query.referer;
	const { utm_medium: utmMedium, utm_source: utmSource, utm_campaign: utmCampaign } = getQueryParams(refererUrl);
	const [forceOktaConnectionDisclaimerType, setForceOktaConnectionDisclaimerType] = useState('');
	const [oktaConnectionEmail, setOktaConnectionEmail] = useState('');

	useTrackGoFromSms('Guaranteed Offer SMS Login', dataTrackGOFromSMS(utmMedium, utmSource, utmCampaign));

	if (forceOktaConnectionDisclaimerType) {
		return <ConnectOkta email={oktaConnectionEmail} disclaimer={forceOktaConnectionDisclaimerType} />;
	}

	return (
		<PublicLayout
			isPublicPage
			isLoginPage
			id="signin"
			meta={{
				title: t('common:logIn'),
				description: 'BacklotCars is now OPENLANE! Access the ultimate wholesale solution. Click to sign in.',
			}}
		>
			<FullHeightTwoColumnLayout
				SecondColumnComp={<FeatureSlider />}
				CardContent={
					<SectionLanding
						passwordForgot={passwordForgot}
						signUpUrl={signUpUrl}
						refererUrl={refererUrl}
						afcSignIn={router.query.mode === 'afc'}
						setForceOktaConnectionDisclaimerType={setForceOktaConnectionDisclaimerType}
						setOktaConnectionEmail={setOktaConnectionEmail}
					/>
				}
			/>
		</PublicLayout>
	);
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
	const user = await getUser(ctx, false);

	if (user?.navigation) {
		const route = getRedirectionPath(user);

		if (route) {
			return {
				redirect: {
					permanent: false,
					destination: route,
				},
			};
		}
	}

	await getTreatments({
		treatments: [splitTreatments.buy_663_okta_only_login_react],
		user,
		store,
	});

	return {
		props: {
			...(await serverSideTranslations(ctx.locale, ['common', 'signin', 'signin-afc', 'okta'])),
		},
	};
});

export default SignIn;
